import { useLocation } from 'react-router-dom';

function useIsHiddenInRoute () {
    const location = useLocation();

    const isHidden = (route) => {
        return route === location.pathname
    }

    return {
        isHidden
    };
}

export default useIsHiddenInRoute;
